import React from 'react';
import './KickstarterStatusBadge.css';
import { useLanguage } from '../switchLang/useLang';

export default function KickstarterStatusBadge() {
    const { t, lang } = useLanguage();
    return (
        <div className="kickstarterBadgeWrapper">
            <div className="kickstarterBadge">
                <span>{t("kickstarterLaunchDate")}</span>
            </div>
        </div>
    );
}